<template>
  <b-card :class="{'bg-gradient-primary': isDragging}" @dragover="dragover"  @dragleave="dragleave" @drop="drop"  style="min-height: 15vh;" >
  <b-card-body>
    <input type="file" :multiple="multiple" name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file" :accept="accept" />

    <label for="fileInput" class="file-label">
      <div v-if="isDragging" style="color: white;">Rilascia per caricare il file.</div>
      <div v-else>Trascina file qui o <u>clicca qui</u> per caricare un File.</div>
    </label>
    <div class="preview-container mt-4" v-if="files.length">
      <div v-for="file in files" :key="file.name"   style="max-width: 30%;" class="p-2 m-1 bg-gradient-secondary preview-card">
        <div>
          <p >
            <b>
            {{ file.name | truncate(8,'...') }}
            <br>
            {{ Math.round(file.size / 1000) + "kb" }}
            </b>
          </p>
        </div>
        <div>
          <b-button class="ml-2" variant="light" type="button" @click="remove(files.indexOf(file))" title="Remove file">
            X
          </b-button>
        </div>
      </div>
    </div>
  </b-card-body>
</b-card>
</template>
  
<script>
import {BButton, BCard, BCardBody} from 'bootstrap-vue'

export default {
  name: 'DropZone',
  components: {
BButton, BCard, BCardBody
  },
    props: {
      accept: {
        type: String,
        required: false,
        default: ''
      },
      multiple: {
        type: Boolean,
        required: false,
        default: true
      }
    },
  data() {
    return {
      isDragging: false,
      files: [],
    };
  },
  methods: {
    onChange() {
      const self = this;
      let incomingFiles = Array.from(this.$refs.file.files);
      if (self.multiple) {
        const fileExist = self.files.some((r) =>
        incomingFiles.some(
          (file) => file.name === r.name && file.size === r.size
        )
      );
      if (fileExist) {
        self.showMessage = true;
        alert("Il file inserito è già presente!");
      } else {
        self.files.push(...incomingFiles);
      }
      } else {
        self.files = incomingFiles;
      }


      
      this.$emit('drop', self.files)
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    remove(i) {
      this.files.splice(i, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import '~@core/scss/base/bootstrap-extended/variables';
@import 'bootstrap/scss/variables';
@import '~@core/scss/base/components/variables-dark';


.is-dragging {
    border-color: red !important;
  }


.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  color: black;
  display: flex;
  margin-top: 2rem;
  flex-wrap: wrap;
}

.preview-card {
  border-radius: 15px;
  display: flex;
  margin-left: 5px;
  border: 30px !important;
  border-color: rgb(22, 29, 49) !important;
}

.preview-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}
</style>